// Classes are in dependency order (all dependency classes are declared first) as classes are not
// hoisted and declaration order matters.
class TimeSlots {
    constructor(timeslot) {
        initField(this, 'timeFrom', timeslot);
        initField(this, 'timeTo', timeslot);
        initField(this, 'name', timeslot);
        initField(this, 'available', timeslot, null, booleanTransformer());
        initField(this, 'appointmentPriceTier', timeslot);

        if (!isUndefinedOrNull(this.name)) {
            let formatTimeSlotsWindows = this.name.split('-');
            this.windowFromTime = formatTimeForDisplay(formatTimeSlotsWindows[0]);
            this.windowToTime = formatTimeForDisplay(formatTimeSlotsWindows[1]);
        }
    }

    isPremiumTimeSlot() {
        return this.name === Premium.Appointment.TIME_SLOT_NAME;
    }

    timeSlotForDisplay(enableNewFormatting = true) {
        if (enableNewFormatting) {
            return this.windowFromTime + ' - ' + this.windowToTime;
        }

        // skip the formatting
        return this.name;
    }

    toJson(removeNull = true) {
        return convertToJSON.call(this, removeNull);
    }
}

class Schedule {
    constructor(schedule) {
        initField(this, 'date', schedule);
        initField(this, 'day', schedule, null, dayOfWeekTransformer());
        initField(this, 'number', schedule);
        initField(this, 'available', schedule, null, booleanTransformer());
        initField(this, 'times', schedule, [], null, defaultTransformer(TimeSlots));
    }

    hasSameDate(dateToCompare) {
        return this.date === dateToCompare;
    }

    toJson(removeNull = true) {
        return convertToJSON.call(this, removeNull);
    }
}

class ScheduleResponse {
    constructor(response) {
        initField(this, 'schedules', response, [], null, defaultTransformer(Schedule));
    }

    toJson(removeNull = true) {
        return convertToJSON.call(this, removeNull);
    }
}